/* 
  科目管理
*/
import request from "@/utils/request";

//获取科目管理信息列表
export function getSubject() {
  return request({
    url: "/sysmange/subject/getSubject",
    method: "get"
  });
}

//添加或者编辑科目信息
export function saveOrUpdate(data) {
  return request({
    url: "/sysmange/subject/saveOrUpdate",
    method: "post",
    data
  });
}

//删除科目
export function deleteSubject(data) {
  return request({
    url: "/sysmange/subject/delete",
    method: "post",
    data
  });
}
